import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import { Field, Form as FormikForm, Formik } from 'formik';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
// import { vendorUnClaimRequest } from '../../Editor/actions';
import { Box } from '@mui/material';
import CustomTypography from '../../../../components/mui/CustomTypography';

import file_off_icon from '../../../../assets/images/file-off-icon.svg';
import CustomModal from '../../../../components/mui/CustomModal';
import { CustomFormControlLabel } from '../../../../components/mui/CustomFormControlLabel';
import { BpCheckbox } from '../../../../components/mui/BpCheckbox';
import { CustomButton } from '../../../../components/mui/CustomButton';
import { proofreaderUnClaimRequest } from '../../Editor/actions';
import { Button } from 'react-bootstrap';
import { trackEvent } from '../../../../utils/ga';

const UnclaimModal = ({ open, onClose, setFilterApiCall }) => {
  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const [loading, setLoading] = useState(false);
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data?.value);
  let editorDetailsData = editorDetails && JSON.parse(editorDetails);
  const initialValues = {
    unclaimReason: [],
    unclaimReasonText: '',
  };

  const handleSubmitProofreaderClaim = (values) => {
    setLoading(true);
    let payload = {
      claimId: editorDetailsData?.ClaimId,
      userId: userInfo?.UserId,
      unclaimReasonText: values?.unclaimReasonText,
      unclaimReason: values?.unclaimReason,
    };
    trackEvent('file_unclaim', {
      file_id: editorDetailsData?.ClaimId,
      file_name: editorDetailsData?.UserFileName,
    });
    dispatch(proofreaderUnClaimRequest(payload));
    setLoading(false);
  };
  // const getButtonLabel = () => {
  //   const claimCount = editorDetailsData && editorDetailsData?.ClaimCount;

  //   if (claimCount === 1) {
  //     return '2nd';
  //   } else if (claimCount === 2) {
  //     return '3rd';
  //   } else {
  //     // Default to "1st" if claimCount is 0, null, or undefined
  //     return '1st';
  //   }
  // };
  return (
    <CustomModal 
      open={open}
      onClose={() => {
        if (loading) return;
        onClose();
      }}
    >
      {/* <div>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px 20px 0 20px',
            textAlign: 'end',
          }}
        >
        
          {editorDetailsData?.ClaimCount === 0 && (
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
              <Box>
                <DescriptionOutlinedIcon
                  sx={{ fontSize: '1.5rem', width: '1em', height: '1em', color: 'var(--sub-primary)' }}
                />
              </Box>
              <Box>
                <DescriptionOutlinedIcon
                  sx={{ fontSize: '1.5rem', width: '1em', height: '1em', color: 'var(--sub-primary)' }}
                />
              </Box>
            </Box>
          )}
          {editorDetailsData?.ClaimCount === 1 && (
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
              <Box>
                <DescriptionOutlinedIcon
                  sx={{ fontSize: '1.5rem', width: '1em', height: '1em', color: 'var(--sub-primary)' }}
                />
              </Box>
            </Box>
          )}
          {editorDetailsData?.ClaimCount === 2 && (
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
              <Box sx={{ pr: 1 }}>
                <img src={file_off_icon} className="img-fluid" alt="file-off-icon" />
              </Box>
            </Box>
          )}
          <HighlightOffRoundedIcon
            onClick={onClose}
            style={{ cursor: 'pointer', opacity: 0.5, height: '28px', width: '28px' }}
          />
        </Box>
        <Formik 
          initialValues={initialValues}
         onSubmit={handleSubmitProofreaderClaim}
         >
          {({ values }) => (
            <FormikForm>
              <div className="preview-dropdown-body">
                <CustomTypography color="error" sx={{ marginBottom: '16px' }}>
                  This is the {getButtonLabel() || '1st'} file you are unclaiming in 24 hours.
                </CustomTypography>
                <CustomTypography color="secondary" size="mediumSmall" sx={{ marginBottom: '16px' }}>
                  You can unclaim up to 3 files every 24 hours. After the 3rd unclaim, your account will be restricted
                  from claiming files for 24 hours.
                </CustomTypography>
                <CustomTypography weight="medium">Why would you like to unclaim this file?</CustomTypography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', rowGap: 1, margin: '16px 0' }}>
                  {['Foreign Language', 'Missing Audio', 'Difficult Audio', 'Technical Problem', 'Other'].map(
                    (reason, index) => (
                      <Box key={index} sx={{ flexBasis: '33.33%' }}>
                        <CustomFormControlLabel
                          control={<BpCheckbox name="unclaimReason" value={reason} />}
                          label={reason}
                        />
                      </Box>
                    ),
                  )}
                </Box>
                <CustomTypography weight="medium" sx={{ marginBottom: '16px' }}>
                  Give us more details about the issue:
                </CustomTypography>
                <Field
                  as="textarea"
                  name="unclaimReasonText"
                  placeholder="Start typing reason..."
                  className="form-control"
                  style={{
                    marginBottom: '16px',
                  }}
                />
                <div className="text-center">
                  <CustomButton
                    sx={{
                      width: '200px',
                      height: '45px',
                    }}
                    variant="secondary"
                    disabled={values?.unclaimReasonText === ''}
                    type="submit" 

                  >
                    Submit
                  </CustomButton>
                </div>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div> */}
      <div>
        <div
          style={{
            padding: '20px 20px 0 20px',
            textAlign: 'end',
          }}
        >
          <HighlightOffRoundedIcon
            onClick={() => {
              if (loading) return;
              onClose();
            }}
            className={`${loading ? 'cursor-not-allowed' : 'cursor-pointer'} opacity-50`}
            style={{ height: '28px', width: '28px' }}
          />
        </div>
        <div className="preview-dropdown-body">
          <h2 className="text-center">Are You Sure?</h2>
          <p className="opacity-70 fnt-20 fw-medium text-center">Are you sure you want to Unclaim this File?</p>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmitProofreaderClaim}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ values, errors, touched }) => (
              <FormikForm>
                <div className="preview-dropdown-body">
                  <Field
                    as="textarea"
                    name="unclaimReasonText"
                    placeholder="Please provide the reason for unclaiming"
                    className="form-control"
                    style={{ height: '100px' }}
                    autoComplete="off"
                  />
                  {errors.unclaimReasonText && touched.unclaimReasonText && (
                    <div className="text-danger mt-1">{errors.unclaimReasonText}</div>
                  )}
                  <div
                    className="mt-3"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Button
                      className="w160"
                      variant="outline-danger"
                      disabled={loading}
                      onClick={() => {
                        if (loading) return;
                        onClose();
                      }}
                      style={{
                        height: '45.49px',
                        borderRadius: '6px',
                        padding: '11px 28px',
                        fontSize: '14px',
                        fontWeight: 600,
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="w160"
                      disabled={values?.unclaimReasonText === '' || loading}
                      onClick={() => {
                        if (loading) return;
                        setFilterApiCall(true);
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </FormikForm>
            )}
          </Formik>
        </div>
      </div>
    </CustomModal>
  );
};

export default UnclaimModal;
